import { TaxSummaryType, type EliteInsightsCta, type TaxSummaryBlock } from '../../types/misc.types'
import { roundOffAndFormatNumberWithCurrency } from '../../utils/utils'

function formatTaxLiabilityPrefix(taxLiability: number): string {
  if (taxLiability === 0) {
    return 'No'
  }
  return roundOffAndFormatNumberWithCurrency(taxLiability)
}

function buildTaxSummaryHighlight(block: TaxSummaryBlock): string | undefined {
  const summaryType = block.summaryType
  if (!summaryType || summaryType === TaxSummaryType.NO_PLAN) {
    return undefined
  }

  if (summaryType === TaxSummaryType.ONLY_TAX_SAVING) {
    return `Save ${roundOffAndFormatNumberWithCurrency(block.taxSavings ?? 0)} in tax`
  }
  if (summaryType === TaxSummaryType.ONLY_BOOK_GAINS) {
    return `Book ${roundOffAndFormatNumberWithCurrency(block.bookGains ?? 0)} gains tax-free`
  }
  if (summaryType === TaxSummaryType.BOOK_GAINS_WITH_TAX_SAVING) {
    return `Book ${roundOffAndFormatNumberWithCurrency(block.bookGains ?? 0)} gains tax-free, and also reduce your tax liability by ${roundOffAndFormatNumberWithCurrency(block.taxSavings ?? 0)}`
  }
  if (summaryType === TaxSummaryType.ALL_OPTIMISED) {
    return 'No tax saving opportunity available'
  }
  return undefined
}

export const NON_ELITE_TAX_SUMMARY_SUBTITLE = 'See how much you owe taxes'

export function buildTaxSummaryDisplay(block: TaxSummaryBlock) {
  const liabilityLine = `${formatTaxLiabilityPrefix(block.taxLiability ?? 0)} tax liability`
  const descriptionLine = `${liabilityLine} • ${block.financialYear ?? ''}`
  return {
    descriptionLine,
    summaryHighlight: buildTaxSummaryHighlight(block)
  }
}

export function resolveTaxSummaryBlock(
  taxSummary?: TaxSummaryBlock,
  legacyTaxSummaryCta?: EliteInsightsCta
): TaxSummaryBlock | undefined {
  if (taxSummary) {
    return taxSummary
  }
  if (!legacyTaxSummaryCta) {
    return undefined
  }
  return {
    cta: legacyTaxSummaryCta,
    financialYear: '',
    taxLiability: 0
  }
}
